import { type ReactNode } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"

type QueryProviderProps = {
  children: ReactNode
}

let queryClient: QueryClient | null = null

export const getQueryClient = () => {
  if (!queryClient) {
    queryClient = new QueryClient()
  }

  return queryClient
}

export function QueryProvider({ children }: QueryProviderProps) {
  return <QueryClientProvider client={getQueryClient()}>{children}</QueryClientProvider>
}
